import './LeanLayout.scss';
import { Outlet } from 'react-router-dom'

function LeanLayout() {
  return (
    <div className='LeanLayout'>
      <Outlet />
    </div>
  )
}

export default LeanLayout